import { CHECKOUT_TAX_ACTIONS, initialCheckoutTaxState } from './checkoutTax.types'

export function checkoutTaxReducer(state = initialCheckoutTaxState, { type, payload }) {
  switch (type) {
    case CHECKOUT_TAX_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case CHECKOUT_TAX_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case CHECKOUT_TAX_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    case CHECKOUT_TAX_ACTIONS.SET_TAX_QUOTE:
      return {
        ...state,
        taxQuoteCents: payload?.total_tax_cents ?? 0,
        taxQuoteData: payload?.data ?? null
      }

    default:
      return state
  }
}
